import React from 'react';
import BlogFAQSection from '../blog/BlogFAQSection';
import StructuredDataFAQ from '@/components/seo/StructuredDataFAQ';
import { executiveCoachingFAQData } from '@/data/faq/executive-coaching-faq';

const ExecutiveCoachingFAQ = () => {
  const faqItems = executiveCoachingFAQData;

  return (
    <section id="faq" className="section-spacing bg-joerg-50">
      <StructuredDataFAQ faqItems={faqItems} pageName="Executive Coaching" />
      <div className="container max-w-4xl">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Häufige Fragen
          </span>
          <h2 className="animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Alles über Executive Coaching & Führungskräfte-Entwicklung
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Erfahren Sie mehr über professionelles Executive Coaching in Bayern und deutschlandweit. Antworten auf die wichtigsten Fragen zu Ablauf, Kosten und Nutzen.
          </p>
        </div>
        
        <BlogFAQSection 
          items={faqItems} 
          title="" 
        />
      </div>
    </section>
  );
};

export default ExecutiveCoachingFAQ;
